<script>
  import {
    activeSpec,
    updateActiveSpec,
    unlockedSpecs,
    unlockSpec,
    lockSpec,
    systemLog,
    unlockedSpecsMemory,
    soloUnlock,
    flushActiveSpec,
    clearSoloUnlock,
    setSoloUnlock,
    setUnlockedSpecsMemory,
    updateUnlockedSpecs
  } from "../../editor/storage.js";
  import { moveToArtboard } from "../../editor/component/artboard.js";
  import {
    openSystemTooltip,
    closeSystemTooltip,
  } from "../../editor/utility.js";
  export let spec, icon;
  function setActive(u) {
    if ($activeSpec !== u && $unlockedSpecs.includes(u)) {
      document
        .querySelectorAll(`#view-${$activeSpec} *.dupo-g-found`)
        .forEach((elem) => elem?.classList.remove("dupo-g-found"));
      activeSpec.set(u);
      updateActiveSpec(u);
      $systemLog.log({ message: "Activate an artboard", artboard_id: u });
    }
  }
  function setInactive(u) {
    activeSpec.set(-1);
    flushActiveSpec();
    $systemLog.log({ message: "Deactivate an artboard", artboard_uid: u });
  }
  // locks
  function isUnlocked(uid) {
    return $unlockedSpecs.includes(uid);
  }
  function togglArtboardLock(uid) {
    if ($soloUnlock !== undefined) {
      // solo-unlock => two locks;
      let old_uid = $soloUnlock;
      unlockSpec(uid);
      $systemLog.log({ message: "Unlock an artboard", artboard_uid: uid });
      clearSoloUnlock();
      $systemLog.log({
        message: "Solo-unlock an artboard",
        artboard_uid: old_uid,
      });
    } else if (isUnlocked(uid)) {
      // unlocked => locked
      lockSpec(uid);
      if ($activeSpec === uid) setInactive(uid);
      $systemLog.log({ message: "Lock an artboard", artboard_uid: uid });
    } else {
      // locked => unlocked
      unlockSpec(uid);
      $systemLog.log({ message: "Unlock an artboard", artboard_uid: uid });
    }
  }
  function toggleSolo(uid) {
    if ($soloUnlock === undefined) {
      // nothing is solo-unlocked
      setSoloUnlock(uid);
      setUnlockedSpecsMemory($unlockedSpecs);
      updateUnlockedSpecs([uid]);
      $systemLog.log({ message: "Set solo", artboard_uid: uid });
    } else if ($soloUnlock !== undefined && $soloUnlock !== uid) {
      // there's existing solo-unlock
      setSoloUnlock(uid);
      updateUnlockedSpecs([uid]);
      $systemLog.log({ message: "Set solo", artboard_uid: uid });
    } else {
      // releasing from solo-unlock
      let old_uid = $soloUnlock;
      clearSoloUnlock();
      updateUnlockedSpecs($unlockedSpecsMemory);
      $systemLog.log({ message: "Unset solo", artboard_uid: old_uid });
    }
  }
</script>

<div class="list-button-wrap">
  <button
    type="button"
    on:click={() => {
      setActive(spec.uid);
      moveToArtboard(spec.uid);
    }}
    on:mouseover={function (event) {
      openSystemTooltip(
        event,
        `Go to ${spec.artboard.name}` +
          `${
            !$unlockedSpecs.includes(spec.uid)
              ? ". To activate, unlock this artboard first."
              : ""
          }`
      );
    }}
    on:mousemove={function (event) {
      openSystemTooltip(
        event,
        `Go to ${spec.artboard.name}` +
          `${
            !$unlockedSpecs.includes(spec.uid)
              ? ". To activate, unlock this artboard first."
              : ""
          }`
      );
    }}
    on:focus={function (event) {
      openSystemTooltip(
        event,
        `Go to ${spec.artboard.name}` +
          `${
            !$unlockedSpecs.includes(spec.uid)
              ? ". To activate, unlock this artboard first."
              : ""
          }`
      );
    }}
    on:blur={() => closeSystemTooltip()}
    on:mouseout={() => closeSystemTooltip()}
    ><i class={`bi bi-${icon} me-1`} />{spec.artboard.name}</button
  >
  <button
    type="button"
    data-role="lock-indicator"
    alt="lock this artboard"
    on:click={() => {
      togglArtboardLock(spec.uid);
    }}
    on:mouseover={function (event) {
      openSystemTooltip(
        event,
        $unlockedSpecs.includes(spec.uid)
          ? "Lock this artboard"
          : "Unlock this artboard"
      );
    }}
    on:mousemove={function (event) {
      openSystemTooltip(
        event,
        $unlockedSpecs.includes(spec.uid)
          ? "Lock this artboard"
          : "Unlock this artboard"
      );
    }}
    on:focus={function (event) {
      openSystemTooltip(
        event,
        $unlockedSpecs.includes(spec.uid)
          ? "Lock this artboard"
          : "Unlock this artboard"
      );
    }}
    on:blur={() => closeSystemTooltip()}
    on:mouseout={() => closeSystemTooltip()}
  >
    <i
      class={`bi bi-${
        $unlockedSpecs.includes(spec.uid) ? "unlock-fill" : "lock"
      }`}
    />
  </button>
  <button
    type="button"
    data-role="solo-indicator"
    alt="solo this artboard"
    on:click={() => {
      toggleSolo(spec.uid);
    }}
    on:mouseover={function (event) {
      openSystemTooltip(
        event,
        $soloUnlock === spec.uid
          ? "Solo this artboard"
          : "Un-solo this artboard"
      );
    }}
    on:mousemove={function (event) {
      openSystemTooltip(
        event,
        $soloUnlock === spec.uid
          ? "Solo this artboard"
          : "Un-solo this artboard"
      );
    }}
    on:focus={function (event) {
      openSystemTooltip(
        event,
        $soloUnlock === spec.uid
          ? "Solo this artboard"
          : "Un-solo this artboard"
      );
    }}
    on:blur={() => closeSystemTooltip()}
    on:mouseout={() => closeSystemTooltip()}
  >
    <span class={$soloUnlock === spec.uid ? "solo-on" : "solo-off"}>S</span>
  </button>
</div>

<style>
  .list-button-wrap {
    display: flex;
    flex-wrap: nowrap;
    justify-content: end;
  }
  button {
    appearance: none;
    display: block;
    background-color: rgba(255, 255, 255, 0.5);
    margin-bottom: 0.5rem;
    padding: 0.2rem 0.5rem 0.2rem 0.5rem;
    border-style: solid;
    border-color: #dddddd;
    border-top-width: 1px;
    border-bottom-width: 1px;
    border-right-width: 1px;
    text-align: right;
    font-size: 0.75rem;
    border-width: 1px 1px 1px 0;
  }
  button:hover {
    font-weight: 500 !important;
    background-color: rgba(255, 255, 255, 0.75);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1), 0 3px 4px rgba(0, 0, 0, 0.05);
  }
  button:first-of-type {
    border-radius: var(--default-radius) 0 0 var(--default-radius);
    border-left-width: 1px;
  }
  button:last-of-type {
    border-radius: 0 var(--default-radius) var(--default-radius) 0;
  }
  .solo-on,
  .solo-off {
    font-family: var(--monospace-font);
    border: 1px solid #454545;
    border-radius: var(--default-radius);
    padding: 1px 0.25rem;
  }
  .solo-on {
    font-weight: 900;
    background-color: #454545;
    color: white;
  }
  .solo-off {
    font-weight: 100;
  }
</style>
